// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"8b1047d9","223":"b773c104","451":"e6e7e70f","613":"d731832f"}[chunkId] + ".chunk.js";
};